// extracted by mini-css-extract-plugin
module.exports = {"brandsList":"BrandsUnderline_brandsList__deFOA","brandsListUnderline":"BrandsUnderline_brandsListUnderline__T6PSB"};